module.exports = __webpack_public_path__ + "img/screenshot04.ffd6e272.png";